// The location map's zoom buttons: + over −, shaped like Google's zoom control, in the theme's light or dark colours
// (styles.tsx ZoomPanel). Google's own control is off (LocationMap's zoomControl option).
import { useEffect, useState } from 'react';
import { ZoomBtn, ZoomDivider, ZoomPanel } from './styles';

// hybrid imagery's usual limit, for when the map type doesn't report its own
const FALLBACK_MAX_ZOOM = 22;

export default function ZoomControl({ map }: { map: google.maps.Map | null }) {
	const [zoom, setZoom] = useState<number | undefined>(() => map?.getZoom());

	// follows every zoom change (buttons, scroll, pinch, fitBounds) so the limits disable the right button
	useEffect(() => {
		if (!map) return;
		setZoom(map.getZoom());
		const listener = map.addListener('zoom_changed', () => setZoom(map.getZoom()));
		return () => listener.remove();
	}, [map]);

	if (!map || zoom === undefined) return null;

	const mapTypeId = map.getMapTypeId();
	const maxZoom: number = (mapTypeId && map.mapTypes.get(mapTypeId)?.maxZoom) ?? FALLBACK_MAX_ZOOM;
	const zoomBy = (step: number) => map.setZoom(zoom + step);

	return (
		<ZoomPanel role='group' aria-label='Map zoom'>
			<ZoomBtn type='button' aria-label='Zoom in' title='Zoom in' disabled={zoom >= maxZoom} onClick={() => zoomBy(1)}>
				<svg width='14' height='14' viewBox='0 0 14 14' aria-hidden='true'>
					<path d='M7 0v14M0 7h14' stroke='currentColor' strokeWidth='2' />
				</svg>
			</ZoomBtn>
			<ZoomDivider />
			<ZoomBtn type='button' aria-label='Zoom out' title='Zoom out' disabled={zoom <= 0} onClick={() => zoomBy(-1)}>
				<svg width='14' height='14' viewBox='0 0 14 14' aria-hidden='true'>
					<path d='M0 7h14' stroke='currentColor' strokeWidth='2' />
				</svg>
			</ZoomBtn>
		</ZoomPanel>
	);
}
